module.exports = __webpack_public_path__ + "static/hubs.fa806a29.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/hubs.jpg
// module id = 547
// module chunks = 0